"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SelectCheckboxItem = function SelectCheckboxItem(_ref) {
  var content = _ref.content,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    icon = _ref.icon,
    selected = _ref.selected,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.checkboxWrapper, _defineProperty({}, _styles.default.hover, !disabled))
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: selected,
    className: _styles.default.checkboxItem,
    disabled: disabled,
    label: content,
    onChange: onClick
  }), icon && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.iconWrapper
  }, icon.title, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames3.default)(_styles.default.icon, _defineProperty({}, _styles.default.disabled, disabled)),
    dangerouslySetInnerHTML: {
      __html: icon.element
    }
  })));
};
SelectCheckboxItem.propTypes = {
  selected: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired,
  content: _propTypes.default.any,
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.shape({
    element: _propTypes.default.string.isRequired,
    title: _propTypes.default.string
  })
};
var _default = exports.default = SelectCheckboxItem;